module.exports = __webpack_public_path__ + "img/profile_green.53724ee8.svg";